import { combineReducers } from "redux";
import webinar from "./Home/webinar";
import investor from "./Home/investor";
import marketNews from "./Home/marketNews";
import adBlock from "./Home/adBlock";
import newOnEdel from "./Home/newOnEdel";
import allOfferings from "./Home/allOfferings";
export default combineReducers({
    webinar,
    investor,
    marketNews,
    adBlock,
    newOnEdel,
    allOfferings,
});
